<template>
  <div class="m-b-15 wholeContainer">
    <ul class="actions"  v-if="!note.deletedAt">

        <li @click="deleteNote(note.id, note.userId)">
           <b-icon icon="trash2-fill" font-scale="1"></b-icon> 
         </li>
         <li @click="editNote(note.id, note.noteContent)">
           <b-icon icon="pencil-square" font-scale="1"></b-icon> 
         </li>
        
       </ul>
     <div class="single-note-main" v-if="!note.deletedAt" v-html="note.noteContent"></div>
     <div class="single-note-main message-deleted" v-else>Message Deleted</div>
     <div class="meta m-t-5">
       <div>
         <div >{{  moment(note.updatedAt).local().format("YYYY-MM-DD") }}</div>
         <div >{{  moment(note.updatedAt).local().format("HH:mm:ss") }}</div>
       </div>
       
       <div class="text-right theposter">- {{ note.User.username }}</div>
     </div>
  </div>
</template>

<script>
import NoteService from '../../services/note.service';
import EventBus from '../../EventBus'
  export default {
    props: {
      note: {
        type: Object,
        default: () => ({})
      }
    },
    methods: {
      async deleteNote(id, userId){
         try{
           console.log("Delete note with id", id, userId)
           const deleteStatus = await NoteService.deleteNote(id);
           EventBus.$emit("note-deleted")
         }
         catch(errors){

           this.$toasted.show(
              errors.response.data.message,
              {
                type: "error",
                duration: 3000,
                action: {
                  text: "Close",
                  class: "toastBtnTxt",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  },
                },
              }
            );

         }
      },
      editNote(id, noteContent){
         EventBus.$emit("edit-note", {id, noteContent})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .single-note-main{
    background-color: rgb(230, 235, 243);
    color: rgb(64, 82, 116);
    padding: 10px 15px;
    border-radius: 5px;
    position: relative;
    font-size: 13px;
    word-break: break-word;
    &.message-deleted{
      background-color: rgb(255, 225, 225);
      color: rgb(243, 56, 56);
      
    }
  }
  .meta{
    font-size: 12px;
    display:flex;
    justify-content: space-between;
  }
  .theposter{
    color: #1991EB;
  }
  .actions{
    list-style-type: none;
    display: flex;
    width: 100%;
    padding-left:0;
    margin-bottom: 5px;
    justify-content: space-between;
    li{
      cursor: pointer;
      opacity: 0;
      /* transform: translate(100px, 0); */
      transition: all 500ms ease;
    
    }
    &:hover li{
      opacity: 1;
      /* transform: translate(0,0); */
      &:last-child{
        color: rgb(56, 182, 255);
      }
      &:first-child{
        color: rgb(252, 59, 59);
      }
    }
  }
  .wholeContainer{
    width: 100%;
    overflow: hidden;
  }
  
</style>